// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.variant-items-dropdown-container[data-v-130e834f] {
  background-color: white;
}
.variant-dropdown-item[data-v-130e834f] {
  cursor: pointer;
}
.variant-dropdown-item[data-v-130e834f]:hover {
  background-color: rgb(206, 241, 255);
}
[data-v-130e834f] .add-variant-button:hover .i-text {
  color: var(--i-text-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/StoryVariantDropdown.vue","webpack://./StoryVariantDropdown.vue"],"names":[],"mappings":"AAEA;EACE,uBAAA;ACDF;ADIA;EAKE,eAAA;ACLF;ADCE;EACE,oCAAA;ACCJ;ADKA;EACE,qCAAA;ACFF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.variant-items-dropdown-container {\n  background-color: white;\n}\n\n.variant-dropdown-item {\n  &:hover {\n    background-color: rgb(206, 241, 255);\n  }\n\n  cursor: pointer;\n}\n\n:deep(.add-variant-button:hover .i-text) {\n  color: var(--i-text-color) !important;\n}\n",".variant-items-dropdown-container {\n  background-color: white;\n}\n\n.variant-dropdown-item {\n  cursor: pointer;\n}\n.variant-dropdown-item:hover {\n  background-color: rgb(206, 241, 255);\n}\n\n:deep(.add-variant-button:hover .i-text) {\n  color: var(--i-text-color) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
